import { useContext, useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  serverTimestamp,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import {
  Autocomplete,
  TextField,
  Button,
  CircularProgress,
  Slide,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
// + on ajoute :
import { LanguageContext } from "../context/LanguageContext";
import { db } from "../firebase";
import BGLogin from "../images/bgapp.png";
import { useTheme } from "@mui/material/styles";

export default function ProfileFormDesktop() {
  const { currentUser } = useAuth();
  // + on récupère le translate
  const { translate } = useContext(LanguageContext); // +
  const [input, setInput] = useState("");
  const [options, setOptions] = useState([]);
  const [, setSelected] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();
  const [inProp, setInProp] = useState(false);
  useEffect(() => {
    setInProp(true);
  }, []);
  const theme = useTheme();

  // on garde la requête Firestore pour suggérer les sociétés
  useEffect(() => {
    const q = query(
      collection(db, "companies"),
      where("name", ">=", input),
      where("name", "<=", input + "\uf8ff")
    );
    return onSnapshot(q, (snap) =>
      setOptions(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [input]);

  async function handleSave() {
    const name = input.trim();
    if (!name) return;
    setConfirmLoading(true);
    const companyId = name;
    const companyRef = doc(db, "companies", companyId);
    const snap = await getDoc(companyRef);

    if (!snap.exists()) {
      await setDoc(companyRef, {
        name,
        memberIds: [currentUser.uid],
        invitedEmails: [],
      });
    } else {
      await updateDoc(companyRef, {
        memberIds: arrayUnion(currentUser.uid),
      });
    }

    await setDoc(
      doc(db, "profilsUsers", currentUser.uid),
      {
        companyId,
        companyName: name,
        role: "Admin",
        joinedAt: serverTimestamp(),
      },
      { merge: true }
    );
    setConfirmLoading(false);
    // navigate("/");
    navigate("/app", { replace: true });
  }

  return (
    // <div className="sign-main-container">
    <div
      className="sign-main-container"
      style={{
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
      }}
    >
      {" "}
      {/* même conteneur que Login */}
      {/* <div className="sign-left-container"> */}
      <Slide
        in={inProp}
        direction="right"
        mountOnEnter
        unmountOnExit
        timeout={400}
      >
        {/* <div className="sign-left-container"> */}
        <div
          className="sign-left-container"
          style={{ color: theme.palette.text.primary }}
        >
          <div
            style={{
              height: "25%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="signup-container-title" style={{ width: "100%" }}>
              <div className="signup-title" style={{ color: "inherit" }}>
                {translate("CompleteYourProfile")} {/* + nouvelle clé */}
              </div>
            </div>
            {/* + description sous le titre */}
            {/* <div style={{ width: "50%" }}> */}
            <div style={{ width: "50%", color: theme.palette.text.secondary }}>
              {translate("ProfileFormDescription")}
            </div>

            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Autocomplete
                freeSolo
                options={options.map((o) => o.name)}
                inputValue={input}
                onInputChange={(_, v) => {
                  setInput(v);
                  setSelected(null);
                }}
                // renderInput={(params) => (
                //   <TextField {...params} label={translate("Company")} />
                // )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={translate("Company")}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: "background.paper",
                        color: "text.primary",
                        "& fieldset": { borderColor: "divider" },
                        "&:hover fieldset": { borderColor: "divider" },
                        "&.Mui-focused fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        color: "text.secondary",
                        "&.Mui-focused": { color: "primary.main" },
                      },
                    }}
                  />
                )}
                style={{ width: 300 }}
              />
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={!input.trim() || confirmLoading}
              >
                {confirmLoading ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  translate("Confirm")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Slide>
      <div
        className="sign-right-container-2"
        style={{
          flex: 1,
          borderLeft: `1.5px solid ${theme.palette.divider}`,
          backgroundImage: `url(${BGLogin})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
}
